export const ACCESS_TOKEN_COOKIE_NAME = 'USER_DATA';
export const USER_ORIGIN_COOKIE_NAME = 'MADPAWS_USER_ORIGIN';
export const ACCESS_TOKEN_TYPE = 'Bearer';
export const MD_AUTH_LOCAL_STORAGE_KEY = 'md_auth';

export const FROM_IN_APP_BROWSER = 'InAppBrowser';
export const SIGN_IN_ROUTE = '/sign-in';
export const SIGN_UP_ROUTE = '/sign-in';

export const ADMIN_USER_COOKIE_NAME = 'admin_user';

export const NATIVE_APP_SIGN_IN_EVENT_NAME = 'NATIVE_APP_SIGN_IN';
